// src/calculations.ts
var valueToPercent = (value, min, max) => {
  return (value - min) * 100 / (max - min);
};
var clampValue = (value, min, max) => {
  return Math.min(Math.max(value, min), max);
};
var range = (from, to) => {
  const length2 = to - from + 1;
  return Array.from({ length: length2 }, (_, index) => index + from);
};

// src/helpers.ts
var isFunction = (param) => {
  return typeof param === "function";
};
function isComponentType(component) {
  return typeof component === "function" || typeof component === "object" && component.$$typeof;
}
function isRenderFunction(value) {
  var _a;
  return typeof value === "function" && !((_a = value.prototype) == null ? void 0 : _a.isReactComponent);
}
var isArray = (param) => {
  return Array.isArray(param);
};
function toArray(param) {
  return isArray(param) ? param : [param];
}
var first = (array) => {
  return isArray(array) && array[0];
};
var last = (array) => {
  return isArray(array) && array[array.length - 1];
};
var length = (array, length2) => {
  return isArray(array) && array.length === length2;
};
var isEmpty = (array) => {
  return length(array, 0);
};
var has = (array, value) => {
  return isArray(array) && array.includes(value);
};
var isNull = (value) => value == null;
var isNumber = (value) => {
  return typeof value === "number" && !Number.isNaN(value);
};
var omitProps = (obj, keys) => {
  const objClone = { ...obj };
  (Array.isArray(keys) ? keys : [keys]).forEach((key) => delete objClone[key]);
  return objClone;
};
var execAllFunctions = (...functions) => (...args) => functions.forEach((fn) => fn == null ? void 0 : fn([...args]));
var __DEV__ = process.env.NODE_ENV !== "production";

// src/warnings.ts
var executeOnce = (fn) => {
  let result;
  let executed = false;
  function once(...args) {
    if (executed) return result;
    executed = true;
    result = fn == null ? void 0 : fn.apply(this, args);
    fn = null;
    return result;
  }
  return once;
};
var conditions = (logOptions, callback) => {
  const { condition, message } = logOptions;
  if (condition && __DEV__) {
    callback(message);
  }
};
var warn = executeOnce((logOptions) => {
  return conditions(logOptions, console.warn);
});
var error = executeOnce((logOptions) => {
  return conditions(logOptions, console.error);
});

// src/merge.ts
import { mergeDeep } from "@stepstone-genesis/deep-merge-library";
var overwriteMerge = (targetArray, sourceArray) => {
  targetArray = sourceArray;
  return targetArray;
};
var mergeAll = (objects, { overwriteArrays } = { overwriteArrays: true }) => {
  return mergeDeep.all(objects, {
    arrayMerge: overwriteArrays ? overwriteMerge : void 0
  });
};

// src/react.ts
import * as React from "react";
var IS_CONCURRENT_REACT = Number(React.version.match(/^\d+/)) >= 18;
var getValidChildren = (children) => React.Children.toArray(children).filter(
  (child) => React.isValidElement(child)
);
var hasChildren = (element) => React.isValidElement(element) && Boolean(element.props.children);
export {
  IS_CONCURRENT_REACT,
  __DEV__,
  clampValue,
  error,
  execAllFunctions,
  executeOnce,
  first,
  getValidChildren,
  has,
  hasChildren,
  isArray,
  isComponentType,
  isEmpty,
  isFunction,
  isNull,
  isNumber,
  isRenderFunction,
  last,
  length,
  mergeAll,
  omitProps,
  range,
  toArray,
  valueToPercent,
  warn
};
